import { IState } from "@/interfaces/IState";
import { IModal } from "@/interfaces/modal/IModal";
import any = jasmine.any;

export const modal = {
    state: {
        dialog: false,
        component: ""
    },
    mutations: {
        UPDATE_MODAL(state: IState, payload: IModal) {
            state.dialog = !state.dialog;
            if (state.dialog) {
                return;
            }
            state.component = null;
        },
        SET_COMPONENT(state: IState, payload: IModal) {
            state.component = payload.component;
        }
    },
    actions: {
        actionToggleModal(context: any, payload: IModal) {
            context.commit("UPDATE_MODAL", payload);
        },
        setComponentModal(context: any, payload: IModal) {
            context.commit("SET_COMPONENT", payload);
        }
    },
    getters: {
        getDialogModal(state: IState) {
            return state.dialog;
        },
        getComponentModal(state: IState) {
            return state.component;
        }
    }
};
